export enum Indices {
    action = 'actions',
    globalNetwork = 'global_network',
    resource = 'resource',
    event = 'event',
    news = 'post',
    contacts = 'contacts',
}